import { isAxiosError } from 'axios'

export class UnifiedPaymentGatewayError extends Error {
  readonly httpStatus?: number
  readonly errorCode?: string
  readonly endpoint?: string
  readonly gatewayResponse?: unknown

  constructor(
    message: string,
    options?: {
      httpStatus?: number
      errorCode?: string
      endpoint?: string
      gatewayResponse?: unknown
      cause?: unknown
    },
  ) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined)
    // eslint-disable-next-line i18next/no-literal-string
    this.name = 'UnifiedPaymentGatewayError'
    this.httpStatus = options?.httpStatus
    this.errorCode = options?.errorCode
    this.endpoint = options?.endpoint
    this.gatewayResponse = options?.gatewayResponse
  }

  static from(error: unknown): UnifiedPaymentGatewayError {
    if (error instanceof UnifiedPaymentGatewayError) {
      return error
    }

    if (isAxiosError(error)) {
      const data = error.response?.data as Record<string, unknown> | undefined
      const backendMessage = typeof data?.message === 'string' && data.message ? data.message : undefined
      const code = typeof data?.code === 'string' && data.code ? data.code : undefined
      const errorCode = code ?? (typeof data?.errorCode === 'string' && data.errorCode ? data.errorCode : undefined)
      return new UnifiedPaymentGatewayError(backendMessage ?? error.message, {
        httpStatus: error.response?.status,
        errorCode,
        endpoint: error.config?.url,
        gatewayResponse: data,
        cause: error,
      })
    }

    if (error instanceof Error) {
      return new UnifiedPaymentGatewayError(error.message, { cause: error })
    }

    // eslint-disable-next-line i18next/no-literal-string
    return new UnifiedPaymentGatewayError(typeof error === 'string' ? error : 'Unknown payment gateway error')
  }
}
